module.exports = __webpack_public_path__ + "img/My-Photo__MYP0687_GC.36bbbfb1.jpg";